interface NetDiagramProps {
  solidId: string;
  name: string;
  description: string;
}

export default function NetDiagram({ solidId, name, description }: NetDiagramProps) {
  const renderNet = () => {
    switch (solidId) {
      case 'rectangular-prism':
        return (
          <svg viewBox="0 0 400 300" className="w-full h-auto max-w-md mx-auto">
            {/* Cross-shaped net */}
            <rect x="100" y="0" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="140" y="35" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Top</text>
            
            <rect x="20" y="60" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="60" y="95" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Left</text>
            
            <rect x="100" y="60" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="140" y="95" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Front</text>
            
            <rect x="180" y="60" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="220" y="95" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Right</text>
            
            <rect x="260" y="60" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="300" y="95" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Back</text>
            
            <rect x="100" y="120" width="80" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="140" y="155" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Bottom</text>
          </svg>
        );

      case 'triangular-prism':
        return (
          <svg viewBox="0 0 400 250" className="w-full h-auto max-w-md mx-auto">
            {/* Three rectangles and two triangles */}
            <rect x="50" y="80" width="100" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="100" y="115" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Lateral 1</text>
            
            <rect x="150" y="80" width="100" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="200" y="115" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Bottom</text>
            
            <rect x="250" y="80" width="100" height="60" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="300" y="115" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Lateral 2</text>
            
            <polygon points="150,20 200,80 100,80" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="150" y="65" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Base 1</text>
            
            <polygon points="250,140 300,200 200,200" fill="#14b8a6" stroke="#0f766e" strokeWidth="2" />
            <text x="250" y="180" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Base 2</text>
          </svg>
        );

      case 'square-pyramid':
        return (
          <svg viewBox="0 0 350 350" className="w-full h-auto max-w-md mx-auto">
            {/* Square base with 4 triangles */}
            <rect x="125" y="125" width="100" height="100" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
            <text x="175" y="180" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Base</text>
            
            <polygon points="175,25 125,125 225,125" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
            <text x="175" y="95" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Front</text>
            
            <polygon points="25,175 125,125 125,225" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
            <text x="90" y="175" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Left</text>
            
            <polygon points="325,175 225,125 225,225" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
            <text x="260" y="175" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Right</text>
            
            <polygon points="175,325 125,225 225,225" fill="#8b5cf6" stroke="#6d28d9" strokeWidth="2" />
            <text x="175" y="260" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Back</text>
          </svg>
        );

      case 'triangular-pyramid':
        return (
          <svg viewBox="0 0 400 300" className="w-full h-auto max-w-md mx-auto">
            {/* Four triangles arranged */}
            <polygon points="200,50 150,150 250,150" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
            <text x="200" y="125" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Face 1</text>
            
            <polygon points="150,150 100,250 200,250" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
            <text x="150" y="215" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Face 2</text>
            
            <polygon points="250,150 200,250 300,250" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
            <text x="250" y="215" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Face 3</text>
            
            <polygon points="200,250 150,250 175,200" fill="#ec4899" stroke="#be185d" strokeWidth="2" />
            <text x="175" y="235" fill="#fff" fontSize="10" fontWeight="bold" textAnchor="middle">Base</text>
          </svg>
        );

      case 'cylinder':
        return (
          <svg viewBox="0 0 400 250" className="w-full h-auto max-w-md mx-auto">
            {/* Two circles and one rectangle */}
            <circle cx="100" cy="80" r="50" fill="#f59e0b" stroke="#d97706" strokeWidth="2" />
            <text x="100" y="85" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Top</text>
            
            <rect x="50" y="150" width="300" height="80" fill="#f59e0b" stroke="#d97706" strokeWidth="2" />
            <text x="200" y="195" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Lateral Surface (wraps around)</text>
            
            <circle cx="300" cy="80" r="50" fill="#f59e0b" stroke="#d97706" strokeWidth="2" />
            <text x="300" y="85" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Bottom</text>
          </svg>
        );

      case 'cone':
        return (
          <svg viewBox="0 0 400 300" className="w-full h-auto max-w-md mx-auto">
            {/* Circle and sector */}
            <circle cx="120" cy="150" r="60" fill="#fb923c" stroke="#ea580c" strokeWidth="2" />
            <text x="120" y="155" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">Base</text>
            
            <path d="M 280 150 Q 320 100 340 50 L 340 250 Q 320 200 280 150 Z" fill="#fb923c" stroke="#ea580c" strokeWidth="2" />
            <text x="310" y="155" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Lateral</text>
            <text x="310" y="170" fill="#fff" fontSize="11" fontWeight="bold" textAnchor="middle">Surface</text>
            <text x="310" y="185" fill="#fff" fontSize="10" textAnchor="middle">(sector)</text>
          </svg>
        );

      case 'sphere':
        return (
          <div className="text-center py-12">
            <div className="w-32 h-32 mx-auto bg-gradient-to-br from-emerald-300 to-emerald-600 rounded-full border-4 border-emerald-700 flex items-center justify-center mb-6">
              <i className="ri-question-line text-5xl text-white"></i>
            </div>
            <p className="text-sm text-slate-700 font-medium max-w-md mx-auto">
              A sphere cannot be unfolded into a flat net without distortion. This is why world maps always distort the true shape of Earth!
            </p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 border-2 border-slate-200">
      <h3 className="text-lg font-bold text-slate-800 mb-4 text-center">Net Diagram (Unfolded Shape)</h3>
      {renderNet()}
      <p className="text-sm text-slate-600 mt-6 text-center italic">{description}</p>
    </div>
  );
}